import {
  createSimpleAxiosErrorNotification,
  createSimpleSuccessNotification,
  createWarningNotification,
} from "../common/notifications/notification";
import {apiService} from "../utils/serviceApi";
import {
  UPDATE_GAS_STATION_KBA_KEY,
  UPDATE_KBA_KEY_RECORD,
  UPDATE_PARKING_ZONE_KBA_KEY,
} from "./types";

export const KBA_ZONE_TYPES = {
  PARKING_ZONE: "parkingZone",
  GAS_STATION: "gasStation",
};

const zoneConfig = {
  [KBA_ZONE_TYPES.PARKING_ZONE]: {
    endpoint: "parking-zone",
    updateType: UPDATE_PARKING_ZONE_KBA_KEY,
  },
  [KBA_ZONE_TYPES.GAS_STATION]: {
    endpoint: "gas-station",
    updateType: UPDATE_GAS_STATION_KBA_KEY,
  },
};

const serviceUrl = () => process.env.REACT_APP_SERVICE_URL;

export const getKbaKey = (kbaKey) => async () => {
  try {
    const res = await apiService.get(`${serviceUrl()}/api/kba-key/${kbaKey}`);
    return res.data;
  } catch (e) {
    createSimpleAxiosErrorNotification(e);
    throw e;
  }
};

export const getGeneratedKbaKey = (zoneType, id) => async () => {
  const config = zoneConfig[zoneType];
  try {
    const res = await apiService.get(
      `${serviceUrl()}/api/${config.endpoint}/${id}/kba-key/generated-value`
    );
    return res.data;
  } catch (e) {
    if (e?.response?.status !== 400) {
      createSimpleAxiosErrorNotification(e);
    }
    throw e;
  }
};

export const assignKbaKey = (zoneType, id, key) => async (dispatch) => {
  const config = zoneConfig[zoneType];
  try {
    const res = await apiService.put(
      `${serviceUrl()}/api/${config.endpoint}/${id}/kba-key`,
      {key}
    );
    const kbaKey = res.data;
    dispatch({
      type: config.updateType,
      payload: {id, kbaKey},
    });
    createSimpleSuccessNotification();
    return kbaKey;
  } catch (e) {
    createSimpleAxiosErrorNotification(e);
    throw e;
  }
};

export const updateKbaKeyStatus = (kbaKey, status, declineReason) => async (dispatch) => {
  try {
    const res = await apiService.patch(
      `${serviceUrl()}/api/kba-key/${kbaKey}/status`,
      {status, declineReason}
    );
    const updatedKbaKey = res.data;
    // A KBA key may be linked to multiple zones; dispatch a key-scoped action
    // so every list/detail row referencing this key reflects the new status.
    dispatch({
      type: UPDATE_KBA_KEY_RECORD,
      payload: {kbaKey: updatedKbaKey},
    });
    createSimpleSuccessNotification();
    return updatedKbaKey;
  } catch (e) {
    if (e?.response?.status === 400) {
      createWarningNotification(e.response?.data?.error || e.message);
    } else {
      createSimpleAxiosErrorNotification(e);
    }
    throw e;
  }
};
